export default __webpack_public_path__ + "static/media/18.c211a81e.png";